<template>
  <div>
    <el-card class="page-container">
      <el-row class="title-biaoti">官方消息发送</el-row>
      <el-row class="search"
        ><el-button type="primary" @click="query" :loading="login"
          >刷新
        </el-button>
        <el-button type="warning" @click="operate(1)">新增 </el-button></el-row
      >
      <el-row>
        <el-table
          :data="datalist"
          style="width: 100%"
          v-loading="login"
          stripe
          border
        >
          <el-table-column prop="noticeId" label="消息ID"> </el-table-column>
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column prop="body" label="内容"> </el-table-column>
          <el-table-column prop="picture" label="图片">
            <template slot-scope="scope" v-if="scope.row.picture">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.picture"
                :preview-src-list="[scope.row.picture]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="jumpType" label="跳转类型"> </el-table-column>
          <el-table-column prop="url" label="链接地址"> </el-table-column>
          <el-table-column prop="ctime" label="创建时间"> </el-table-column>
          <el-table-column prop="mtime" label="修改时间"> </el-table-column>
          <el-table-column prop="valid" label="是否有效">
            <template slot-scope="scope">
              {{ scope.row.valid == 0 ? '无效' : '有效' }}
            </template>
          </el-table-column>
          <el-table-column prop="sendFcm" label="推送FCM">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.sendFcm == 1" type="success">是</el-tag>
              <el-tag v-else type="danger">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="fcmIcon" label="FCM图标">
            <template slot-scope="scope" v-if="scope.row.fcmIcon">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.fcmIcon"
                :preview-src-list="[scope.row.fcmIcon]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="ridStr" label="发送用户id"> </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
        </el-table>
      </el-row>
      <el-dialog
        title="新增"
        :visible.sync="dialog"
        width="50%"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div v-if="data.bodyType === 1" style="margin-bottom: 10px">
          <el-button
            @click="activeIndex = 0"
            :type="!activeIndex ? 'primary' : ''"
            >基础信息</el-button
          >
          <el-button
            @click="activeIndex = 1"
            :type="activeIndex ? 'primary' : ''"
            >富文本</el-button
          >
        </div>
        <div class="base-detail" v-show="activeIndex === 0">
          <div class="item">
            <span>标题：</span
            ><el-input type="text" v-model="data.title"></el-input>
          </div>
          <div class="item">
            <span>文本类型</span>
            <el-select v-model="data.bodyType" placeholder="请选择">
              <el-option label="普通文本" :value="0"></el-option>
              <el-option label="富文本" :value="1"></el-option>
            </el-select>
          </div>
          <div class="item" v-if="data.bodyType == 0">
            <span>内容：</span
            ><el-input type="text" v-model="data.body"></el-input>
          </div>
          <div class="item" v-else>
            <span>语言：</span>
            <el-select v-model="data.language" placeholder="请选择">
              <el-option label="英语" value="en"></el-option>
              <el-option label="阿语" value="ar"></el-option>
              <el-option label="西语" value="es"></el-option>
              <el-option label="all" value=""></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>图片：</span
            ><el-upload
              class="avatar-uploader"
              action=""
              :auto-upload="false"
              :show-file-list="false"
              :on-change="changfile"
              ref="upload"
            >
              <el-image
                v-if="data.picture !== ''"
                style="width: 178px; height: 178px"
                :src="data.picture"
                fit="scale-down"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>

          <div class="item">
            <!-- 跳转类型，el-option, -->
            <span>跳转类型：</span>
            <el-select v-model="data.jumpType" placeholder="请选择">
              <el-option
                v-for="item in jumpType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-if="data.jumpType != 1">
              <span>内部跳转渠道：</span>
              <el-select v-model="data.jumpPage" placeholder="请选择">
                <el-option
                  v-for="item in jumpPage"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="item" v-if="data.jumpType == 1 || data.jumpPage == 19">
            <span>跳转地址：</span
            ><el-input type="text" v-model="data.url"></el-input>
          </div>
          <!-- 字段rid，jumpPage为5/8的时候显示必填 -->
          <div class="item" v-if="data.jumpPage === 5 || data.jumpPage === 8">
            <span>详情 RID：</span
            ><el-input type="text" v-model="data.rid"></el-input>
          </div>
          <div class="item">
            <span>接受人群：</span>
            <el-select v-model="data.userGroup" placeholder="请选择">
              <el-option
                v-for="item in userGroup"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>国家：</span>
            <el-select
              multiple
              v-model="data.countryCodeList"
              placeholder="请选择"
            >
              <el-option
                v-for="item in countryList"
                :key="item.countryCode"
                :label="item.country"
                :value="item.countryCode"
              >
              </el-option>
            </el-select>
          </div>

          <div class="item">
            <!-- 渠道筛选 -->
            <span>渠道筛选：</span>
            <el-select multiple v-model="data.channelList" filterable placeholder="请选择">
              <el-option
                v-for="item in channels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>是否推送FCM：</span>
            <el-select v-model="data.sendFcm" placeholder="请选择">
              <el-option
                v-for="item in [
                  { name: '是', value: 1 },
                  { name: '否', value: 0 },
                ]"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 字段gameDetail，jumpPage为1时显示 -->
          <div class="item" v-if="data.jumpPage == 1">
            <span>游戏详情：</span
            ><el-input type="text" v-model="data.gameDetail"></el-input>
          </div>
          <div v-if="data.userGroup === 7">
            <div class="item">
              <span>发送人id(多个,隔开)：</span
              ><el-input type="text" v-model="data.ridStr"></el-input>
            </div>
            <div class="item">
              <span>文件导入发送人：</span
              ><el-upload
                class="avatar-uploader"
                action=""
                :auto-upload="false"
                :show-file-list="true"
                :on-change="addExcel"
                ref="upload1"
              >
                <el-button type="danger">导入excel</el-button>
              </el-upload>
            </div>
          </div>
          <!-- 推动FM的时候显示 -->
          <div v-if="data.sendFcm === 1">
            <div class="item">
              <span>FCM图标：</span>
              <el-upload
                class="avatar-uploader"
                action=""
                :auto-upload="false"
                :show-file-list="false"
                :on-change="changfile1"
                ref="upload2"
              >
                <el-image
                  v-if="data.fcmIcon !== ''"
                  style="width: 178px; height: 178px"
                  :src="data.fcmIcon"
                  fit="scale-down"
                ></el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>
        <div v-show="activeIndex === 1" :dir="data.language === 'ar' ? 'rtl' : 'ltr'">
          <RichEdit ref="edit" v-model="data.richBody" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="operate(2)" type="primary" :loading="dwnload">
            新 增
          </el-button>
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { timestampToTime } from '@/utils/common'
import RichEdit from '@/components/RichEdit/RichEdit.vue'
export default {
  components: {
    RichEdit,
  },
  data() {
    return {
      activeIndex: 0,
      login: false,
      dwnload: false,
      datalist: [],
      dialog: false,
      //国家列表
      countryList: [],
      data: {
        title: '',
        body: '',
        picture: '',
        url: '',
        ridStr: '',
        file: '',
        jumpPage: '',
        jumpType: 1,
        bodyType: 0,
        language: 'en',
        userGroup: '',
        channelList: '',
        richBody: '',
        gameDetail: '',
        rid: '',
        sendFcm: 0,
        fcmIcon: '',
        countryCodeList: '',
      },
      pageInfo: {
        page: 1,
        total: 0,
        size: 30,
      },
      jumpPage: [],
      jumpType: [
        {
          name: 'H5跳转',
          value: 1,
        },
        {
          name: '内部跳转',
          value: '',
        },
      ],
      userGroup: [
        // 1注册7天内用户 2注册7天内主播 3在线用户 4在线主播 5贵族用户 6vip用户 7指定人群
        {
          name: '注册7天内用户',
          value: 1,
        },
        {
          name: '注册7天内主播',
          value: 2,
        },
        {
          name: '在线用户',
          value: 3,
        },
        {
          name: '在线主播',
          value: 4,
        },
        {
          name: '贵族用户',
          value: 5,
        },
        {
          name: 'vip用户',
          value: 6,
        },
        {
          name: '指定人群',
          value: 7,
        },
        {
          name: '渠道内所有人(全局)',
          value: 8,
        },
        {
          name: '渠道内用户(全局)',
          value: 9,
        },
        {
          name: '渠道内主播(全局)',
          value: 10,
        },
      ],
      channels: this.$store.state.channels,
    }
  },
  created() {
    this.query()
    this.getType()
    this.getCountryCode()
    this.getChannel()
  },
  methods: {
        // 获取渠道选项
        async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channels = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    changeRichBaseBody(value) {
      this.data.body = value
    },
    async getType() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.notice_type,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) return this.$message('获取跳转类型失败')
      this.jumpPage = res.data
    },
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList.filter(
          (item) => item.countryCode != 'all' && item.countryCode != 'total'
        )
      }
    },
    async query() {
      this.login = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.notice_history,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.datalist = res.data.data
      this.datalist.map((item) => {
        if (item.ctime !== 0) item.ctime = timestampToTime(item.ctime)
        if (item.mtime !== 0) item.mtime = timestampToTime(item.mtime)
      })
    },
    async operate(type) {
      if (type == 1) {
        //
        this.dialog = true
      } else if (type == 2) {
        let formdata = new FormData()
        // 提交赋值，使用统一的格式化方法，确保和copy按钮格式一致
        this.data.richBody = this.$refs.edit.getFormattedHtml()

        if (this.data.title == '') return this.$message('标题不能为空')
        if (this.data.bodyType == 0 && this.data.body == '')
          return this.$message('内容不能为空')
        if (this.data.jumpPage == 1 && this.data.gameDetail == '')
          return this.$message('游戏详情不能为空')
        if (
          (this.data.jumpPage == 5 || this.data.jumpPage == 8) &&
          this.data.rid === ''
        )
          return this.$message('详情RID不能为空')

        formdata.append('title', this.data.title)
        if (this.data.bodyType === 1) {
          this.data.body = this.$refs.edit.getBaseBody()
        } else {
          this.data.richBody = ''
          this.data.language = ''
        }
        console.log(this.data.richBody)
        formdata.append('bodyType', this.data.bodyType)
        formdata.append('language', this.data.language)
        formdata.append('body', this.data.body)
        formdata.append('richBody', this.data.richBody)
        formdata.append('picture', this.data.picture)
        formdata.append('jumpType', this.data.jumpType)
        formdata.append('url', this.data.url)
        formdata.append('ridStr', this.data.ridStr)

        if (this.data.file != '') formdata.append('file', this.data.file)
        formdata.append('operator', this.$store.getters.username)
        if (this.data.jumpType !== 1)
          formdata.append('jumpPage', this.data.jumpPage)
        if (this.data.jumpPage === 1)
          formdata.append('gameDetail', this.data.gameDetail)
        if (this.data.sendFcm === 1)
          formdata.append('fcmIcon', this.data.fcmIcon)
        formdata.append('sendFcm', this.data.sendFcm)
        formdata.append('userGroup', this.data.userGroup)
        formdata.append('countryCodeList', this.data.countryCodeList)
        formdata.append('channelList', this.data.channelList)
        formdata.append('rid', this.data.rid)
        const { data: res } = await this.$axios.post(
          `${this.$store.getters.path.notice_send}?username=${this.$store.getters.username}&token=${this.$store.getters.token}`,
          formdata
        )
        if (res.code != 0) return this.$message.error(res.msg)
        this.handleClose()
        this.$refs.edit.html = ''
        this.$message.success('新增成功')
        this.query()
      }
    },
    handleClose() {
      this.data = this.$options.data.call(this).data
      this.activeIndex = 0
      if (this.$refs.upload) this.$refs.upload.clearFiles()
      if (this.$refs.upload1) this.$refs.upload1.clearFiles()
      if (this.$refs.upload2) this.$refs.upload2.clearFiles()
      this.dialog = false
    },
    async changfile(file) {
      this.dwnload = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'img/user/office/notice/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )
      this.dwnload = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.data.picture = res.data
    },
    async changfile1(file) {
      this.dwnload = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'img/user/office/notice/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )
      this.dwnload = false
      if (res.code !== 0) {
        this.$refs.upload2.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.data.fcmIcon = res.data
    },
    addExcel(file) {
      this.data.file = file.raw
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;

  > * {
    margin: 0 3px;
  }
}

.item {
  display: flex;
  align-items: center;
  padding: 5px 0;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
